import React from "react";
import Icon from "./Icon";

export function KpiGrid({ children, columns, style = {}, className = "" }) {
  const gridStyle = {
    ...(columns
      ? { gridTemplateColumns: typeof columns === "number" ? `repeat(${columns}, 1fr)` : columns }
      : {}),
    ...style,
  };

  return (
    <div className={`kpi-grid ${className}`} style={gridStyle}>
      {children}
    </div>
  );
}

export function KpiCard({
  icon,
  label,
  value,
  color = "#1D4ED8",
  bg = "#EFF6FF",
  active = false,
  subtext,
  onClick,
  style = {},
  className = "",
}) {
  const cardStyle = {
    "--kpi-color": color,
    "--kpi-bg": bg,
    cursor: onClick ? "pointer" : "default",
    ...style,
  };

  return (
    <div
      className={`kpi-card ${active ? "kpi-card--active" : ""} ${className}`}
      style={cardStyle}
      onClick={onClick}
    >
      <div className="kpi-card__icon-box">
        <Icon name={icon || "layers"} size={16} color={color} />
      </div>
      <div className="kpi-card__content">
        <div className="kpi-card__value">{value !== undefined && value !== null ? value : "—"}</div>
        <div className="kpi-card__label" title={label}>{label}</div>
        {subtext && <div className="kpi-card__subtext">{subtext}</div>}
      </div>
    </div>
  );
}

export default KpiCard;
